import { Deposition } from './depositions/Deposition';
import { fetchZenodo } from './fetchZenodo';
export class Zenodo {
    host;
    accessToken;
    baseURL;
    constructor(options) {
        const { accessToken, host = 'sandbox.zenodo.org' } = options;
        this.host = host;
        this.baseURL = `https://${host}/api/`;
        if (!accessToken) {
            throw new Error('accessToken is required');
        }
        this.accessToken = accessToken;
    }
    async listDepositions(options = {}) {
        // all the values must be string
        const optionsWithStrings = Object.fromEntries(Object.entries(options).map(([key, value]) => [key, String(value)]));
        const response = await fetchZenodo(this, {
            route: 'deposit/depositions',
            searchParams: optionsWithStrings,
        });
        const depositions = (await response.json());
        return depositions.map((deposition) => new Deposition(this, deposition));
    }
    async createDeposition(metadata) {
        const response = await fetchZenodo(this, {
            route: 'deposit/depositions',
            expectedStatus: 201,
            method: 'POST',
            body: JSON.stringify({ metadata }),
        });
        const deposition = new Deposition(this, await response.json());
        return deposition;
    }
    async retrieveDeposition(id) {
        const response = await fetchZenodo(this, {
            route: `deposit/depositions/${id}`,
        });
        const deposition = await response.json();
        return new Deposition(this, deposition);
    }
    async deleteDeposition(id) {
        await fetchZenodo(this, {
            method: 'DELETE',
            route: `deposit/depositions/${id}`,
            expectedStatus: 204,
        });
    }
}
//# sourceMappingURL=Zenodo.js.map